import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, FileText, Info } from "lucide-react";
import { COLORS } from "@/lib/api";

const INFORMES = [
  { year: "2025", label: "Informe de Resultados 2025", file: "/docs/informe-2025.pdf", c: COLORS.purple },
  { year: "2024", label: "Informe de Resultados 2024", file: "/docs/informe-2024.pdf", c: COLORS.magenta },
  { year: "2023", label: "Informe de Resultados 2023", file: "/docs/informe-2023.pdf", c: COLORS.orange },
  { year: "2022", label: "Informe de Resultados 2022", file: "/docs/informe-2022.pdf", c: COLORS.lime },
  { year: "2021", label: "Informe Financiero 2021", file: "/docs/informe-2021.pdf", c: COLORS.yellow },
];

const Informes = () => {
  return (
    <div data-testid="subpage-informes" className="max-w-4xl mx-auto px-6 md:px-12 py-16">
      <Link
        to="/conocenos"
        data-testid="subpage-back"
        className="inline-flex items-center gap-2 text-sm font-semibold text-brand-ink/60 hover:text-brand-ink mb-8"
      >
        <ArrowLeft size={16} /> Conócenos
      </Link>

      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <span className="inline-block w-16 h-1.5 rounded-sm mb-6" style={{ background: COLORS.magenta }} />
        <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-brand-ink">
          Informes de Resultados
        </h1>
        <p className="mt-5 text-lg text-brand-ink/70 leading-relaxed">
          Los Informes de Resultados Anuales recopilan de manera transparente los logros, avances y
          actividades realizadas durante cada año. Su propósito es mostrar el impacto del movimiento
          en el liderazgo juvenil, la igualdad de género y el desarrollo de proyectos comunitarios,
          además de fortalecer la rendición de cuentas y mostrar cómo se utilizan los recursos.
        </p>
      </motion.div>

      <div className="mt-8 flex items-start gap-3 bg-white border border-[#E5E5E5] rounded-sm p-5">
        <Info size={20} className="text-brand-magenta flex-shrink-0 mt-0.5" />
        <p className="text-sm text-brand-ink/70 leading-relaxed">
          Sylvia Rodríguez, Luisa Castro y Diana Fernández fundaron{" "}
          <span className="font-semibold text-brand-ink">Girl Up ALC A.C.</span> como asociación civil,
          equipo hoy públicamente reconocido como{" "}
          <span className="font-semibold text-brand-ink">Juventudes Latentes</span>. Los informes de{" "}
          <span className="font-semibold text-brand-ink">2021 a 2025</span> corresponden a esa etapa,
          operada bajo la marca Girl Up México. A partir de 2026, hemos transitado hacia un modelo de
          impacto comunitario más local y actualmente no mantenemos ninguna relación con la marca
          "Girl Up".
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
        {INFORMES.map((inf) => (
          <a
            key={inf.year}
            href={inf.file}
            target="_blank"
            rel="noopener noreferrer"
            download
            data-testid={`informe-${inf.year}`}
            className="group flex items-center gap-4 bg-white border border-[#E5E5E5] rounded-sm p-5 transition-all duration-300 hover:-translate-y-1"
            onMouseEnter={(e) => (e.currentTarget.style.borderColor = inf.c)}
            onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#E5E5E5")}
          >
            <span className="w-12 h-12 rounded-sm flex items-center justify-center flex-shrink-0" style={{ background: inf.c }}>
              <FileText size={22} className="text-white" strokeWidth={2.2} />
            </span>
            <div>
              <span className="font-mono text-xs text-brand-ink/40">{inf.year}</span>
              <p className="font-heading text-lg font-semibold tracking-tight text-brand-ink leading-tight">
                {inf.label}
              </p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default Informes;
